import { Delete as Trash2 } from "@mui/icons-material";
import { Typography, Box, Button, IconButton, Paper } from "@mui/material";
import React from "react";

interface ITemplateItemProps {
    disableDelete: boolean;
    template: {
        id_e: string;
        document_title: string;
        enterprise: string;
        project: string;
        created_at: Date;
    };
    onApply: () => void;
    onDelete: (templateId: string) => void;
}

const TemplateItem: React.FC<ITemplateItemProps> = ({
    disableDelete = false,
    template,
    onApply,
    onDelete,
}) => {
    const handleChose = () => {
        onApply();
    };

    const handleDelete = () => {
        onDelete(template.id_e);
    };

    return (
        <Paper sx={{ p: 2, mb: 1 }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Box>
                    <Typography variant="subtitle1" fontWeight="medium">
                        {template.document_title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {new Date(template.created_at).toLocaleDateString(
                            "pt-BR"
                        )}
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                    <Button
                        size="small"
                        onClick={handleChose}
                        disabled={disableDelete}
                    >
                        Aplicar
                    </Button>
                    <IconButton
                        disabled={disableDelete}
                        size="small"
                        onClick={handleDelete}
                    >
                        <Trash2 fontSize="small" />
                    </IconButton>
                </Box>
            </Box>
        </Paper>
    );
};

export default TemplateItem;
